module.exports = __webpack_public_path__ + "static/img/kb-card-img-02-01@m.534fbc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-img-02-01@m.jpg
// module id = ejS1
// module chunks = 0